export default __webpack_public_path__ + "static/media/ae_scriptrunner.png";